var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-page"},[(_vm.isMobile)?_c('mobile-cart-view'):_c('desktop-cart-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }